var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPicking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 29.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(-104.945 109.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699",
    transform: "translate(104.945 -109.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M20.149,12.8a1.159,1.159,0,0,1-.581-.156L7.233,5.534A1.165,1.165,0,0,1,8.4,3.516l12.335,7.113a1.165,1.165,0,0,1-.583,2.174Z",
    transform: "translate(-0.483 -0.334)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M15.65,30.888a3.911,3.911,0,0,1-1.953-.523l-9.589-5.48A3.92,3.92,0,0,1,2.15,21.5V10.538A3.918,3.918,0,0,1,4.1,7.158l9.6-5.485a3.906,3.906,0,0,1,3.9,0l9.589,5.48a3.92,3.92,0,0,1,1.958,3.381V21.5a3.918,3.918,0,0,1-1.953,3.38l-9.6,5.485A3.906,3.906,0,0,1,15.65,30.888Zm0-27.406a1.578,1.578,0,0,0-.788.211l-9.6,5.485a1.579,1.579,0,0,0-.784,1.361V21.5a1.58,1.58,0,0,0,.788,1.362l9.589,5.48a1.576,1.576,0,0,0,1.581,0l9.6-5.485A1.579,1.579,0,0,0,26.82,21.5V10.538a1.58,1.58,0,0,0-.788-1.362L16.443,3.7A1.583,1.583,0,0,0,15.65,3.482Z",
    transform: "translate(-2.15 -1.152)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M15.55,15.361a1.164,1.164,0,0,1-.583-.157L3,8.283A1.165,1.165,0,1,1,4.168,6.267L15.55,12.85,26.932,6.267A1.165,1.165,0,1,1,28.1,8.283L16.133,15.2A1.164,1.164,0,0,1,15.55,15.361Z",
    transform: "translate(-2.05 0.685)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M12.315,27.3A1.165,1.165,0,0,1,11.15,26.13V12.315a1.165,1.165,0,1,1,2.33,0V26.13A1.165,1.165,0,0,1,12.315,27.3Z",
    transform: "translate(1.185 2.553)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPicking);
export default __webpack_public_path__ + "static/media/OrderPicking.deaaae839c11756bccf4d1b450c07f2c.svg";
export { ForwardRef as ReactComponent };